export function normalizeWalletTokenDecimals(decimals: bigint | number): number {
  const parsedDecimals = Number(decimals);

  if (!Number.isSafeInteger(parsedDecimals) || parsedDecimals < 0) {
    throw new Error('Token decimals value is invalid.');
  }

  return parsedDecimals;
}
